import { render, staticRenderFns } from "./assinatura-fatura.vue?vue&type=template&id=8f35e1f2"
import script from "./assinatura-fatura.vue?vue&type=script&lang=js"
export * from "./assinatura-fatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports